export default "__VITE_ASSET__CbaFOpLn__"